import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createGenerationSite,
  listGenerationSites,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/** 発電所 (サイト) の登録 mutation。成功したら一覧を最新化する。 */
export function useCreateGenerationSite(): InvalidatingMutationResultFor<
  typeof createGenerationSite
> {
  return useInvalidatingMutation(createGenerationSite, [
    createConnectQueryKey({
      schema: listGenerationSites,
      cardinality: 'finite',
    }),
  ])
}
